export default "__VITE_ASSET__7fad5aeb__"